<template>
  <div class="chart flex-column flex-justify-start flex-align-center" :class="[{'card-gap': gap}]">
    <div class="tb-head flex-row flex-justify-start flex-align-center">
      <div class="tdw15 flex-row flex-justify-center flex-align-center">
        <span>编号</span>
      </div>
      <div class="tdw15 flex-row flex-justify-center flex-align-center">
        <span>设备名称</span>
      </div>
      <div class="tdw15 flex-row flex-justify-center flex-align-center">
        <span>类型</span>
      </div>
      <div class="tdw40 flex-row flex-justify-center flex-align-center">
        <span>问题</span>
      </div>
      <div class="tdw15 flex-row flex-justify-center flex-align-center">
        <span>时间</span>
      </div>
    </div>
    <div class="tb-line flex-row flex-justify-start flex-align-center" v-for="(item, index) in errlogs" :key="index">
      <div class="tdw15 flex-row flex-justify-center flex-align-center">
        <span>{{ item.id }}</span>
      </div>
      <div class="tdw15 flex-row flex-justify-center flex-align-center">
        <span>{{ item.name }}</span>
      </div>
      <div class="tdw15 flex-row flex-justify-center flex-align-center">
        <span>{{ item.type }}</span>
      </div>
      <div class="tdw40 flex-row flex-justify-center flex-align-center">
        <span>{{ item.issue }}</span>
      </div>
      <div class="tdw15 flex-row flex-justify-center flex-align-center">
        <span>{{ item.time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrTab',
  props: {
    gap: {
      type: Boolean,
      default: true
    },
    errlogs: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.chart {
  width: 49.5%;
  height: 437px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  overflow: auto;
  padding-bottom: 10px;
}
.card-gap {
  margin-right: 1%;
}
.tb-head {
  width: 96%;
  min-height: 30px;
  margin-top: 10px;
  background-color: #e8f1ff;
  font-family: 'Arial';
  font-size: 14px;
  color: #3d5ad0;
}
.tb-line {
  width: 96%;
  min-height: 30px;
  font-family: 'Arial';
  font-size: 14px;
  color: #c0c0c0;
}
.tdw15 {
  width: 15%;
  min-width: 120px;
}
.tdw40 {
  width: 40%;
  min-width: 240px;
}
</style>
